import { BoxProps } from "@chakra-ui/layout";
import type { NodeTypes } from "@xyflow/react";
import { CircleNode } from "features/entities/EntityCreatePage/EntityGraph/nodes/CircleNode";
import { OvalNode } from "features/entities/EntityCreatePage/EntityGraph/nodes/OvalNode";
import { ParallelogramNode } from "features/entities/EntityCreatePage/EntityGraph/nodes/ParallelogramNode";
import { PlainNode } from "features/entities/EntityCreatePage/EntityGraph/nodes/PlainNode";
import { RectangleNode } from "features/entities/EntityCreatePage/EntityGraph/nodes/RectangleNode";
import { TriangleNode } from "features/entities/EntityCreatePage/EntityGraph/nodes/TriangleNode";
import { EntityFunctionalTypeEnum } from "gen/model/entityFunctionalTypeEnum";

export const getType = (
  type?: EntityFunctionalTypeEnum,
): {
  type: keyof typeof allNodeButDraft;
  backgroundColor: BoxProps["background"];
} => {
  switch (type) {
    case "main_fund":
    case "master_fund":
    case "parallel_fund":
      return { type: "triangle", backgroundColor: "indigo.800" };
    case "feeder_fund":
      return { type: "triangle", backgroundColor: "gray.400" };
    case "coinvestment_vehicle":
    case "joint_venture":
      return { type: "triangle", backgroundColor: "eggplant.500" };
    case "alternative_investment_vehicle":
      return { type: "triangle", backgroundColor: "gray.400" };
    case "blocker":
      return { type: "rectangle", backgroundColor: "gray.400" };
    case "investor":
    case "general_partner":
    case "general_partner_and_special_limited_partner":
    case "special_limited_partner":
    case "unmanaged":
      return { type: "circle", backgroundColor: "cyan.600" };
    case "holding_company":
    case "aggregator":
    case "phantom_aggregator":
      return {
        type: "parallelogram",
        backgroundColor: "teal.600",
      };
    case "investment":
    case "investment_property":
      return { type: "oval", backgroundColor: "green.300" };
    default:
      return { type: "plain", backgroundColor: "white" };
  }
};

export const allNodeButDraft = {
  triangle: TriangleNode,
  rectangle: RectangleNode,
  circle: CircleNode,
  parallelogram: ParallelogramNode,
  oval: OvalNode,
  plain: PlainNode,
} as const satisfies NodeTypes;

export const getNodeFromType = (
  type?: EntityFunctionalTypeEnum,
): {
  type: NodeTypes[keyof typeof allNodeButDraft];
  backgroundColor: BoxProps["background"];
} => {
  const nodeType = getType(type);
  return {
    type: allNodeButDraft[nodeType.type],
    backgroundColor: nodeType.backgroundColor,
  };
};
